export default "__VITE_ASSET__Bkw77Apn__"